import React, { useState, useEffect } from 'react';
import Header from '../components/Header';  // Ensure the path is correct

function Leaderboard({ user }) {
  const [leaderboard, setLeaderboard] = useState([]);

  useEffect(() => {
    const fetchLeaderboard = async () => {
      try {
        const response = await fetch('http://localhost:3001/api/leaderboard');  // Ensure correct API URL
        if (!response.ok) {
          throw new Error('Failed to fetch leaderboard');
        }
        const data = await response.json();
        setLeaderboard(data);
      } catch (error) {
        console.error('Error fetching leaderboard:', error);
      }
    };

    fetchLeaderboard();
  }, []);

  return (
    <div className="bg-darkBackground min-h-screen">
      {/* Pass the user prop to Header to display the username */}
      <Header user={user} />
      
      <div className="p-8">
        <h2 className="text-3xl font-bold text-textWhite mb-8">Leaderboard</h2>

        <table className="table-auto w-full bg-gray-800 text-white">
          <thead>
            <tr>
              <th className="px-4 py-2">Rank</th>
              <th className="px-4 py-2">Username</th>
              <th className="px-4 py-2">Points</th>
              <th className="px-4 py-2">Challenges Solved</th>
            </tr>
          </thead>
          <tbody>
            {leaderboard.length > 0 ? (
              leaderboard.map((user, index) => (
                <tr key={user.username} className="border-t border-gray-700">
                  <td className="px-4 py-2">{index + 1}</td>
                  <td className="px-4 py-2">{user.username}</td>
                  <td className="px-4 py-2">{user.points}</td>
                  <td className="px-4 py-2">
                    {user.solved_challenges.length > 0
                      ? user.solved_challenges.join(', ')
                      : 'None'}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center px-4 py-2">
                  No leaderboard data available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Leaderboard;
